export const GET_CALENDER_DATA = 'get_calender_data';
export const SET_CALENDER_DATA = 'set_calender_data';
